import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { RootPaths } from '@fcom/core/constants';
import { OndMarketingRoutesPath } from '@fcom/ond-marketing-landing-core/interfaces/ond-marketing-offers.interface';
import { LanguageService } from '@fcom/ui-translate';

interface RouteLink {
  href: string;
  translationKey: string;
}

@Component({
  selector: 'cms-ond-marketing-route-links-full-width',
  templateUrl: './cms-ond-marketing-route-links-full-width.component.html',
  styleUrls: ['./cms-ond-marketing-route-links-full-width.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CmsOndMarketingRouteLinksFullWidthComponent {
  private readonly languageService = inject(LanguageService);

  private readonly lang = `/${this.languageService.langValue}/`;

  readonly links: RouteLink[] = [
    { path: OndMarketingRoutesPath.FROM, translationKey: 'from' },
    { path: OndMarketingRoutesPath.FROM_COUNTRY, translationKey: 'fromCountry' },
    { path: OndMarketingRoutesPath.CITY_TO_CITY, translationKey: 'cityToCity' },
    { path: OndMarketingRoutesPath.COUNTRY_TO_COUNTRY, translationKey: 'countryToCountry' },
  ].map(({ path, translationKey }) => ({
    href: `${this.lang}${RootPaths.OND_MARKETING_LANDING_ROOT}/${path}`,
    translationKey,
  }));
}
